import { add, startOfToday, startOfDay, format, formatISO, parse, parseISO, isAfter, isEqual, isBefore } from 'date-fns';
import { isNullOrEmptyString, isNullOrUndefined } from '../helpers';

const dateService = {
	today: () => {
		return startOfToday();
	},
	parse: (dateStr) => {
		// M/dd/yyyy ddd
		if (isNullOrEmptyString(dateStr))
			return new Date();

		return parse(dateStr, 'M/dd/yyyy EEE', new Date());
	},
	isInRange: (dateToTest, startDate, endDate) => {
		if (isNullOrUndefined(dateToTest) || isNullOrUndefined(startDate) || isNullOrUndefined(endDate))
			return false;

		let dateAfter = isAfter(dateToTest, startDate) || isEqual(dateToTest, startDate);
		let dateBefore = isBefore(dateToTest, endDate) || isEqual(dateToTest, endDate);

		return dateAfter && dateBefore;
	}
};

const dateInstance = Object.freeze(dateService);
export { dateInstance as DateService };